'use strict';
var ibmParallaxScroll = (function () {
    function ibmParallaxScroll() {
        this.restrict = 'A';
    }
    ibmParallaxScroll.instance = function () {
        return new ibmParallaxScroll;
    };
    ibmParallaxScroll.prototype.link = function (scope, element, attrs) {
        var $el = element;
        var scrollspeed = $el.data("scrollspeed") || 2;
        var backgroundX = $el.css("backgroundPosition").split(" ")[0];
        var disabledSmall = $el.data("disablesmallgrid");
        // Add class that sets the proper styles.
        $el.addClass("ibm-parallax-scroll");
        function adjustImage() {
            var $window = $(window), bgpos = backgroundX + " " + -Math.floor((Math.floor($window.scrollTop()) - Math.floor($el.offset()
                .top)) / scrollspeed) + "px";
            if (disabledSmall && $("html").hasClass("ibm-grid-small")) {
                return;
            }
            $el.css("background-position", bgpos);
        }
        // Bind the background to shift whenever the page scrolls.
        $(window).scroll(adjustImage);
        // Adjust image onload.
        adjustImage();
    };
    return ibmParallaxScroll;
}());
angular
    .module('application')
    .directive('ibmParallaxScroll', ibmParallaxScroll.instance);

//# sourceMappingURL=ibm-parallax-scroll.js.map
